export function toArray(records) {
  return records.map(record => {
    return record.toJSON();
  });
}
